<!--Vista para mostrar el detalle de un plan(afiliación)-->
<template>
  <v-container fluid class="pa-0 grey lighten-3">
    <v-row justify="center" class="mb-5">
      <v-col cols="12" class="py-0">
        <!-- SECCIÓN DE LA IMÁGEN DEL EVENTO -->
        <div class="img-gradient"></div>
        <v-row justify="start" align="center" class="pa-0 pos-relative mx-0 banner-container">
          <v-img
            v-if="currentPlan.planImage!=''"
            :src="currentPlan.planImage"
            lazy-src="https://picsum.photos/id/11/10/6"
            class="banner-img"
          ></v-img>
          <div v-else class="banner-img" v-bind:style="organizerBackground">
            <!-- COMPONENTE DE PARTÍCULAS -->
            <vue-particles
              class="particles"
              color="#dedede"
              :particleOpacity="0.3"
              :particlesNumber="100"
              shapeType="circle"
              :particleSize="2"
              linesColor="#dedede"
              :linesWidth="1"
              :lineLinked="true"
              :lineOpacity="0.1"
              :linesDistance="150"
              :moveSpeed="2"
              :hoverEffect="false"
              :clickEffect="false"
            ></vue-particles>
            <!-- COMPONENTE DE PARTÍCULAS -->
          </div>

          <!-- EMPRESA Y AFILIACIÓN -->
          <v-col cols="12" sm="7" md="7" lg="7" xl="6" class="text-center pa-0 banner-content">
            <v-card class="pa-0">
              <v-container fluid class="py-0">
                <v-row justify="center" align="center">
                  <v-col cols="12" sm="6" class="primary">
                    <v-avatar
                      :size="($vuetify.breakpoint.lgAndUp)?125:($vuetify.breakpoint.mdOnly)?85:95"
                      class="mb-1"
                      v-if="currentPlan.organizer"
                    >
                      <img :src="currentPlan.organizer.profilePicture" alt="avatar" />
                    </v-avatar>
                    <h2
                      class="headline white--text"
                      v-if="currentPlan.organizer"
                    >{{ currentPlan.organizer.companyName }}</h2>
                  </v-col>
                  <v-col cols="12" sm="6" class="pa-1 pa-lg-5">
                    <v-row>
                      <v-col cols="12">
                        <h1 class="text-center display-2 font-weight-bold">Afiliación</h1>
                        <h2 class="headline">{{ currentPlan.name }}</h2>
                      </v-col>
                    </v-row>
                  </v-col>
                </v-row>
              </v-container>
            </v-card>
          </v-col>
          <!-- EMPRESA Y AFILIACIÓN -->
        </v-row>

        <!-- EMPRESA Y AFILIACIÓN MÓVILES -->
        <v-row justify="center">
          <v-col
            cols="12"
            sm="7"
            md="8"
            lg="7"
            xl="6"
            class="text-center pa-0 banner-content-mobile"
          >
            <v-card class="pa-0">
              <v-container fluid class="py-0">
                <v-row justify="center" align="center">
                  <v-col cols="12" sm="6" class="primary py-10">
                    <v-avatar :size="120" class="mb-3" v-if="currentPlan.organizer">
                      <img :src="currentPlan.organizer.profilePicture" alt="avatar" />
                    </v-avatar>
                    <h2
                      class="headline white--text"
                      v-if="currentPlan.organizer"
                    >{{ currentPlan.organizer.companyName }}</h2>
                  </v-col>
                  <v-col cols="12" sm="6" class="pa-1 pa-lg-5">
                    <v-row>
                      <v-col cols="12">
                        <h1 class="text-center display-2 font-weight-bold">Afiliación</h1>
                        <h2 class="headline">{{ currentPlan.name }}</h2>
                      </v-col>
                    </v-row>
                  </v-col>
                </v-row>
              </v-container>
            </v-card>
          </v-col>
        </v-row>
        <!-- EMPRESA Y AFILIACIÓN MÓVILES-->

        <!-- REDES SOCIALES Y DATOS DE CONTACTO -->
        <v-row justify="center">
          <v-col
            v-if="socialMediaItems.length>0"
            class="py-5 py-md-10 px-10 text-center white--text primary"
          >
            <h1 class="headline font-weight-bold mb-2">Redes sociales</h1>
            <a
              :href="(item.value.includes('http'))?`${item.value}`: `http://${item.value}`"
              target="_blank"
              v-for="(item, index) in socialMediaItems"
              :key="index"
              class="mr-3 white--text"
            >
              <v-icon left color="accent" v-bind:style="getSmallSize">{{ item.icon }}</v-icon>
              <span class="text-capitalize">{{ item.name }}</span>
            </a>
          </v-col>
          <v-col
            v-if="contactDetailsItems.length>0"
            class="py-5 py-md-10 px-10 white--text text-center primary"
          >
            <h1 class="headline font-weight-bold mb-2">Datos de contacto</h1>
            <span v-for="(item, index) in contactDetailsItems" :key="index" class="mr-3">
              <v-icon class="mr-1" color="accent" v-bind:style="getSmallSize">{{ item.icon }}</v-icon>
              {{ item.value }}
            </span>
            <a
              :href="(currentPlan.contactDetails.webSite.includes('http'))?`${currentPlan.contactDetails.webSite}`:`http://${currentPlan.contactDetails.webSite}`"
              target="_blank"
              class="mr-3 white--text"
              v-if="currentPlan.contactDetails.webSite!=''"
            >
              <v-icon
                left
                color="accent"
                v-bind:style="getSmallSize"
              >{{ contactDetailsIcons.webSite }}</v-icon>Sitio web
            </a>
          </v-col>
        </v-row>
        <!-- REDES SOCIALES Y DATOS DE CONTACTO -->

        <!-- DESCRIPCIÓN DEL EVENTO -->
        <v-row justify="center" class="event-content mb-10">
          <v-col cols="10" md="11" class="elevation-3 white pb-0">
            <v-row justify="center" class="py-10" data-aos="zoom-in" data-aos-duration="400">
              <v-col cols="11" sm="10">
                <h1 class="display-2 font-weight-bold">Detalles generales de la Afiliación</h1>
              </v-col>

              <v-col cols="12">
                <!-- NIVELES DE AFILIACIÓN -->
                <v-row justify="center" data-aos="fade-up" data-aos-duration="300">
                  <v-col cols="11" sm="10">
                    <h1 class="headline font-weight-bold">Niveles de la afiliación</h1>
                  </v-col>
                  <v-col cols="12" sm="10" v-if="currentPlan.tiers && doneFetching">
                    <pricing-list :tiers="currentPlan.tiers"></pricing-list>
                  </v-col>
                </v-row>
                <!-- NIVELES DE AFILIACIÓN -->
              </v-col>

              <!-- NOMBRE -->
              <v-col cols="11" sm="10" data-aos="fade-up" data-aos-duration="400">
                <h1 class="headline font-weight-bold">Nombre de la afiliación</h1>
                <p>{{ currentPlan.name }}</p>
              </v-col>
              <!-- NOMBRE -->

              <!-- CONTENIDO PERSONALIZADO DEL EVENTO -->
              <v-col cols="11" sm="10" data-aos="fade-up" data-aos-duration="400">
                <span class="event-custom-content" v-html="currentPlan.details"></span>
              </v-col>
              <!-- CONTENIDO PERSONALIZADO DEL EVENTO -->

              <!-- PREGUNTAS FRECUENTES DEL EVENTO -->
              <v-col
                cols="11"
                sm="10"
                data-aos="fade-up"
                data-aos-duration="400"
                v-if="currentPlan.faqs.length>0 && currentPlan.faqs[0].question!=''"
              >
                <h1 class="headline font-weight-bold mb-3">Preguntas frecuentes</h1>
                <faq-panel :questions="currentPlan.faqs"></faq-panel>
              </v-col>
              <!-- PREGUNTAS FRECUENTES DEL EVENTO -->
            </v-row>

            <!-- VIDEO DEL EVENTO -->
            <v-col v-if="currentPlan.socialMedia.youtube != ''" cols="12" class="pa-0">
              <v-row justify="center" class="text-center">
                <v-col
                  v-if="currentPlan.socialMedia.youtube"
                  cols="10"
                  md="5"
                  lg="5"
                  style="flex-wrap:wrap"
                  class="mb-10 mb-md-10"
                  data-aos="fade-right"
                  data-aos-duration="400"
                >
                  <h1 class="headline font-weight-bold mb-5">Video publicitario</h1>
                  <iframe
                    width="100%"
                    v-bind:style="getVideoHeight"
                    :src="getVideoLink"
                    frameborder="0"
                    allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                    allowfullscreen
                  ></iframe>
                </v-col>
              </v-row>
            </v-col>
            <!-- VIDEO DEL EVENTO -->

            <v-row
              justify="center"
              class="grey lighten-3 text-center pb-10"
              data-aos="fade-up"
              data-aos-duration="200"
              v-if="currentPlan.sponsors.length > 0"
            >
              <!-- PATROCINADORES -->
              <v-col cols="12">
                <h2 class="display-1 font-weight-bold mb-8">Nuestros patrocinadores</h2>
              </v-col>
              <v-col
                cols="4"
                md="3"
                lg="2"
                v-for="(sponsor, index) in currentPlan.sponsors"
                :key="index"
              >
                <v-row justify="center" align="center" class="fill-height">
                  <img :src="sponsor" class="sponsor-img" />
                </v-row>
              </v-col>
              <!-- PATROCINADORES -->
            </v-row>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <w-footer></w-footer>
  </v-container>
</template>
<script>
import wFooter from "@/components/shared/w-footer";
import pricingList from "@/components/shared/pricing/pricingList";
import faqPanel from "@/components/landing/faq-panel";
import { mapState, mapMutations, mapActions } from "vuex";
import * as Vibrant from "node-vibrant";
import { Base64 } from 'js-base64';

export default {
  components: {
    wFooter,
    faqPanel,
    pricingList
  },
  data() {
    return {
      doneFetching: false,
      eventDate: [],
      socialMediaIcons: {
        facebook: "fab fa-facebook-square",
        twitter: "fab fa-twitter-square",
        linkedin: "fab fa-linkedin"
      },
      contactDetailsIcons: {
        webSite: "fas fa-globe",
        tel: "fas fa-phone",
        email: "fas fa-envelope"
      },
      organizerBackground: ""
    };
  },
  computed: {
    ...mapState("plan", ["currentPlan"]),
    /**
     * Función que da formato a las redes sociales que se presentan en el evento
     */
    socialMediaItems() {
      if (this.currentPlan) {
        let data = [];
        for (let item in this.currentPlan.socialMedia) {
          if (
            this.currentPlan.socialMedia[item] != "" &&
            item != "youtube" &&
            item != "__typename"
          )
            data.push({
              name: item,
              value: this.currentPlan.socialMedia[item],
              icon: this.socialMediaIcons[item]
            });
        }
        return data;
      }
    },
    /**
     * Función que da formato a los datos de contacto que se presentan en el evento
     */
    contactDetailsItems() {
      let data = [];
      for (let item in this.currentPlan.contactDetails) {
        if (
          this.currentPlan.contactDetails[item] != "" &&
          item != "webSite" &&
          item != "__typename"
        )
          data.push({
            name: item,
            value: this.currentPlan.contactDetails[item],
            icon: this.contactDetailsIcons[item]
          });
      }
      return data;
    },
    /**
     * Función que toma el tamaño de la pantalla del dispositivo para dar tamaño a los iconos
     */
    getSmallSize() {
      switch (this.$vuetify.breakpoint.name) {
        case "xs":
          return "font-size:1.2em";
        case "sm":
          return "font-size:1em";
        case "md":
          return "font-size:1em";
        case "lg":
          return "font-size:1.1em";
        case "xl":
          return "font-size:1.3em";
      }
    },
    /**
     * Función que sirve para poner la altura del contenedor del video de youtube
     */
    getVideoHeight() {
      switch (this.$vuetify.breakpoint.name) {
        case "xs":
          return "height:200px";
        case "sm":
          return "height:250px";
        case "md":
          return "height:300px";
        case "lg":
          return "height:350px";
        case "xl":
          return "height:400px";
      }
    },
    /**
     * Función para formatear url del video de youtube
     */
    getVideoLink() {
       let youtubeId = "";
      if (
        this.currentPlan.socialMedia &&
        this.currentPlan.socialMedia.youtube
      ) {
        if (
          this.currentPlan.socialMedia.youtube.startsWith("https://youtu.be/")
        ) {
          youtubeId = this.currentPlan.socialMedia.youtube.split(
            "https://youtu.be/"
          )[1];
        } else {
          if (this.currentPlan.socialMedia.youtube.includes("?v=")) {
            youtubeId = this.currentPlan.socialMedia.youtube.split("?v=")[1];
          } 
          else if (this.currentPlan.socialMedia.youtube.includes("&v=")) {
            youtubeId = this.currentPlan.socialMedia.youtube.split("&v=")[1];
          }
        }
        youtubeId = youtubeId.split("&")[0];
        return `https://www.youtube.com/embed/${youtubeId}`;
      }
    }
  },
  methods: {
    ...mapActions("plan", ["fetchPlanDetails"]),
    ...mapMutations("loader", ["loading", "loaded"]),
    /**
     * Función para poner un color degradado de fondo en el encabezado, 
     * en caso de que el organizador no cuente con imagen de encabezado.
     * LA IMAGEN QUE SE TOMA PARA PONER EL COLOR DE FONDO DEL DEGRADADO ES LA DE PERFIL DE ORGANIZADOR.
     */
    async getOrganizerBackground() {
      let newImg = `${
        this.currentPlan.organizer.profilePicture
      }?q=${Date.now()}`;
      let { LightVibrant, DarkVibrant } = await Vibrant.from(newImg)
        .maxColorCount(2)
        .getPalette();
      this.organizerBackground = `background-image: linear-gradient(315deg, ${LightVibrant.hex} 0%, ${DarkVibrant.hex} 74%);`;
    }
  },
  async mounted() {
    this.loading();
    await this.fetchPlanDetails(this.$route.params.id);
    // Quitar formato de base 64 en preguntas frecuentes
    this.currentPlan.faqs.forEach(faq => {
      faq.answer = Base64.decode(faq.answer);
    });
    // Quitar preguntas frecuentes que estan en blanco
    for (let i = 0; i < this.currentPlan.faqs.length; i++) {
      if (this.currentPlan.faqs[i].question == "") {
        this.currentPlan.faqs.splice(i, 1);
      }
    }
    // Quitar formato de base 64 en detalles del evento
    this.currentPlan.details = Base64.decode(this.currentPlan.details);
    await this.getOrganizerBackground();
    this.doneFetching = true;
    this.loaded();
  }
};
</script>
<style scoped>
a {
  text-decoration: none !important;
}
.particles {
  height: 100%;
  position: relative;
  z-index: 2;
}
.event-custom-content >>> h1,
h2,
h3,
h4 {
  font-weight: 700 !important;
}
.event-custom-content >>> blockquote {
  border-left: 4px solid #ccc !important;
  margin-bottom: 5px !important;
  margin-top: 5px !important;
  padding-left: 16px !important;
}
.banner-container {
  position: relative;
}
.img-gradient {
  position: absolute;
  background: rgb(0, 0, 0);
  background: linear-gradient(
    0deg,
    rgba(0, 0, 0, 0.65) 0%,
    rgba(255, 255, 255, 0) 100%
  );
  z-index: 1;
}
.sponsor-img {
  filter: grayscale(1);
  height: auto;
  max-height: 100px;
  width: 100%;
  max-width: 150px;
  transition: 0.2s all ease-in-out;
}
.sponsor-img:hover {
  transform: scale(1.15);
}
.event-content {
  margin-top: 35px;
}
@media (max-width: 399px) {
  .img-gradient {
    display: none;
  }
  .sponsor-img {
    max-height: 90px;
    max-width: 130px;
  }
  .banner-img,
  .banner-container {
    height: 200px;
    width: 100%;
  }
  .banner-content {
    display: none;
  }
  .banner-content-mobile {
    display: block;
  }
  .event-custom-content >>> h1 {
    font-size: 1.05em !important;
  }
  .event-custom-content >>> h2 {
    font-size: 1em !important;
  }
  .event-custom-content >>> h3 {
    font-size: 0.95em !important;
  }
}
@media (min-width: 400px) and (max-width: 599px) {
  .img-gradient {
    display: none;
  }
  .sponsor-img {
    max-height: 90px;
    max-width: 130px;
  }
  .banner-img,
  .banner-container {
    height: 200px;
    width: 100%;
  }
  .banner-content {
    display: none;
  }
  .banner-content-mobile {
    display: block;
  }
  .event-custom-content >>> h1 {
    font-size: 1.05em !important;
  }
  .event-custom-content >>> h2 {
    font-size: 1em !important;
  }
  .event-custom-content >>> h3 {
    font-size: 0.95em !important;
  }
}
@media (min-width: 600px) and (max-width: 959px) {
  .img-gradient {
    height: 450px;
    width: 100%;
  }
  .sponsor-img {
    max-height: 90px;
    max-width: 130px;
  }
  .banner-img,
  .banner-container {
    height: 450px;
    width: 100%;
  }
  .banner-content {
    position: absolute;
    transition: 0.13s all ease-in-out;
    bottom: 50px;
    z-index: 2;
  }
  .banner-content-mobile {
    display: none;
  }
  .event-custom-content >>> h1 {
    font-size: 1em !important;
  }
  .event-custom-content >>> h2 {
    font-size: 0.95em !important;
  }
  .event-custom-content >>> h3 {
    font-size: 0.9em !important;
  }
}
@media (min-width: 960px) and (max-width: 1263px) {
  .img-gradient {
    height: 570px;
    width: 100%;
  }
  .sponsor-img {
    max-height: 90px;
    max-width: 130px;
  }
  .banner-img,
  .banner-container {
    height: 570px;
    width: 100%;
  }
  .banner-content {
    position: absolute;
    transition: 0.13s all ease-in-out;
    bottom: 50px;
    z-index: 2;
  }
  .banner-content-mobile {
    display: none;
  }
  .event-custom-content >>> h1 {
    font-size: 1.2em !important;
  }
  .event-custom-content >>> h2 {
    font-size: 1em !important;
  }
  .event-custom-content >>> h3 {
    font-size: 0.9em !important;
  }
}
@media (min-width: 1264px) and (max-width: 1599px) {
  .img-gradient {
    height: 570px;
    width: 100%;
  }
  .sponsor-img {
    max-height: 90px;
    max-width: 130px;
  }
  .banner-img,
  .banner-container {
    height: 570px;
    width: 100%;
  }
  .banner-content {
    position: absolute;
    transition: 0.13s all ease-in-out;
    bottom: 50px;
    z-index: 2;
  }
  .banner-content-mobile {
    display: none;
  }
  .event-custom-content >>> h1 {
    font-size: 1.28em !important;
  }
  .event-custom-content >>> h2 {
    font-size: 1.2em !important;
  }
  .event-custom-content >>> h3 {
    font-size: 1em !important;
  }
}
@media (min-width: 1599px) and (max-width: 1903px) {
  .img-gradient {
    height: 600px;
    width: 100%;
  }
  .sponsor-img {
    max-height: 90px;
    max-width: 130px;
  }
  .banner-img,
  .banner-container {
    height: 600px;
    width: 100%;
  }
  .banner-content {
    position: absolute;
    transition: 0.13s all ease-in-out;
    bottom: 50px;
    z-index: 2;
  }
  .banner-content-mobile {
    display: none;
  }
  .event-custom-content >>> h1 {
    font-size: 1.5em !important;
  }
  .event-custom-content >>> h2 {
    font-size: 1.2em !important;
  }
  .event-custom-content >>> h3 {
    font-size: 1.1em !important;
  }
}
@media (min-width: 1904px) {
  .img-gradient {
    height: 650px;
    width: 100%;
  }
  .sponsor-img {
    max-height: 90px;
    max-width: 130px;
  }
  .banner-img {
    height: 650px;
    width: 100%;
  }
  .banner-container {
    height: 650px;
    width: 100%;
  }
  .banner-content {
    position: absolute;
    transition: 0.13s all ease-in-out;
    bottom: 50px;
    z-index: 2;
  }
  .banner-content-mobile {
    display: none;
  }
  .event-custom-content >>> h1 {
    font-size: 1.5em !important;
  }
  .event-custom-content >>> h2 {
    font-size: 1.2em !important;
  }
  .event-custom-content >>> h3 {
    font-size: 1.1em !important;
  }
}
</style>